import React from "react";
const AboutUs = ({ classicHeader, darkTheme }) => {
  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Know Me More
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>

        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              I'm <span className="text-primary">Alkin Maystorov</span>, a
              Software Engineer dedicated to building high-performance,
              interactive digital experiences.
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              I have over two years of professional experience in frontend
              development and hands-on experience in backend API integration. I
              am skilled at turning complex requirements into scalable,
              responsive applications. I have a history of optimizing web apps
              for speed, managing code complexity, and collaborating across
              teams to deliver seamless user experiences. I have a strong
              interest in computer graphics and interactive systems and I am
              excited to apply real-time rendering, mathematics and state
              architecture principles to modern web technologies. I am good at
              mixing good software engineering with visually dynamic interfaces
              and providing an optimization-oriented approach to both frontend
              and full-stack teams.
            </p>
          </div>

          {/* about me personal detials start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Alkin Maystorov
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="mailto:alkin971@gmail.com">alkin971@gmail.com</a>
                </li>
                <li>
                  <span className="fw-600 me-2">Location:</span>Hamburg, Germany
                </li>
              </ul>
              <a
                href="alkin_maystorov_resume.pdf"
                download
                className="btn btn-primary rounded-pill"
              >
                Download CV
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
